import axios from "axios";
import { getAuth } from "firebase/auth";

const BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

const FavoritesService = {

  async getFavorites() {
    try {
      const auth = getAuth();
  
      // Ждём, пока Firebase восстановит сессию
      await auth.authStateReady();
  
      const u = auth.currentUser;
  
      if (!u) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      const token =
        await u.getIdToken(true);
  
      const body = {
        user_id: u.uid
      };
  
      const res =
        await axios.post(
          `${BASE_URL}/get_favorites`,
          body,
          {
            headers: {
              "Content-Type":
                "application/json",
  
              Authorization:
                `Bearer ${token}`,
            },
          }
        );
  
      return res.data;
  
    } catch (error) {
      /*
       * Если backend вернул 401 —
       * сессия недействительна.
       */
      if (
        error?.response?.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      console.error(
        "❌ Ошибка при получении избранных вакансий:",
        error
      );
  
      return [];
    }
  },

  async getToken() {
    const u = getAuth().currentUser;
    if (!u) throw new Error("Нет авторизованного пользователя");
    return u.getIdToken(true);
  },

  async toggleFavorite(vacancyId) {
    const auth = getAuth();
    const u = auth.currentUser;
    if (!u) throw new Error("Нет авторизованного пользователя");

    const token = await u.getIdToken(true);

    const normVacancyId =
      typeof vacancyId === "string"
        ? vacancyId
        : (vacancyId?.id ?? vacancyId?.vacancyID ?? vacancyId?.vacancy_id ?? String(vacancyId ?? ""));

    const payload = {
      user_id: u.uid,         
      vacancy_id: normVacancyId
    };

    const res = await axios.post(`${BASE_URL}/toggle_vacancy_favorite`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return res.data; 
  },
};

export default FavoritesService;